import {useQuery, useInfiniteQuery, useQueryClient, useMutation} from "react-query";
import {toast} from 'react-toastify';
import API from './utils/api';
import {
    ExplicitDeductionDto, ExplicitDeductionPaginator,
    CreateExplicitDeductionDto, QueryExplicitDeductionDto,
    UpdateExplicitDeductionDto,
    SearchExplicitDeductionDto
} from "../models/explicit-deduction.dto";
import ENDPOINTS from "./utils/endpoints";
import {QueryOptionsDto} from "../models/generic.dto";

export function useGetExplicitDeduction(options?: QueryExplicitDeductionDto) {
    const url = ENDPOINTS.PROCESSING_COMPANY.EXPLICIT_DEDUCTION.GET;
    const request = (options: QueryExplicitDeductionDto) => API.ProcessingCompanyAPI.getExplicitDeduction(options);

    const { data, isLoading, error, refetch } = useQuery<ExplicitDeductionPaginator, Error>(
        [url, options],
        ({ queryKey, pageParam }) => request(Object.assign({}, queryKey[1], pageParam)),
        { ...API.Handlers.pageParamOption }
    );

    return { data, isLoading, error, refetch };
}

export function useGetExplicitDeductionSearch(options?: SearchExplicitDeductionDto) {

    return useMutation(
        (options?: SearchExplicitDeductionDto) => API.ProcessingCompanyAPI.getExplicitDeductionSearch(options),
        {
            onSuccess: () => {
                //toast.success('Record created successfully');
            },
            onError: API.Handlers.onErrorHandler,
        },
    );
}

export function useGetExplicitDeductionById(id: number) {
    const url = ENDPOINTS.PROCESSING_COMPANY.EXPLICIT_DEDUCTION.DETAIL;
    const request = API.ProcessingCompanyAPI.getExplicitDeductionById(id);

    const {data, isLoading, error} = useQuery<{ data:ExplicitDeductionDto }, Error>(
        [url, id],
        (() => request),
        {
            enabled: !!(id),
        }
    );

    return {
        data: data,
        isLoading,
        error,
    };
}
export function useCreateExplicitDeduction() {
    const queryClient = useQueryClient();

    return useMutation(
        ({payload}: {payload: CreateExplicitDeductionDto}) => API.ProcessingCompanyAPI.createExplicitDeduction(payload),
        {
            onSuccess: () => {
                toast.success('Record created successfully');
                queryClient.invalidateQueries(ENDPOINTS.PROCESSING_COMPANY.EXPLICIT_DEDUCTION.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}

export function useUpdateExplicitDeduction() {
    const queryClient = useQueryClient();

    return useMutation(
        ({payload, id}: {payload: UpdateExplicitDeductionDto, id: number}) => API.ProcessingCompanyAPI.updateExplicitDeduction(id, payload),
        {
            onSuccess: () => {
                toast.success('Record updated successfully');
                queryClient.invalidateQueries(ENDPOINTS.PROCESSING_COMPANY.EXPLICIT_DEDUCTION.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}

export function useDeleteExplicitDeduction() {

    return useMutation(
        ({ id}: {id: number}) => API.ProcessingCompanyAPI.deleteExplicitDeduction(id),
        {
            onSuccess: () => {
                toast.success('Record deleted successfully');
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}

export function useUploadExplicitDeduction() {

    return useMutation(
            ({ payload, companyId }: { payload: FormData; companyId: number }) =>
                API.ProcessingCompanyAPI.uploadExplicitDeduction(companyId, payload),
            {
                onSuccess: () => {
                },
                onError: API.Handlers.onErrorHandler,
                onSettled: () => {},
            }
        );
}